module.exports = __webpack_public_path__ + "img/default-image.c5a00375.jpeg";